import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { GraduationCap, Briefcase, Building2, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const ForConsultants = () => {
  const { t } = useLanguage();

  const brands = [
    { 
      key: "datastudent", icon: GraduationCap, href: "/datastudent", label: "DataStudent", color: "primary" as const,
      desc: "Snel een gemotiveerde junior data professional nodig? Via DataStudent leveren wij flexibel jong talent op basis van detachering, vaak kunnen we al binnen twee weken operationeel aan het werk zijn."
    },
    { 
      key: "newdataselect", icon: Briefcase, href: "/new-data-select", label: "New Data Select", color: "accent" as const,
      desc: "Op zoek naar een vaste data- of tech-professional? New Data Select vindt de juiste match voor uw team, duurzaam en op maat."
    },
    { 
      key: "dutchdatacompany", icon: Building2, href: "/dutch-data-company", label: "Dutch Data Company", color: "primary" as const,
      desc: "Een complex data- of AI-project dat senior expertise vraagt? Dutch Data Company levert ervaren specialisten voor strategisch resultaat."
    },
  ];

  return (
    <section id="consultants" className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
            New Data Frontier, thuisbasis voor dataprofessionals die bouwen aan groei.
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-6 leading-tight">
            {t('consultantsPage.funnelTitle')}
          </h3>
          <p className="text-lg text-muted-foreground">
            {t('consultantsPage.funnelSubtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {brands.map((brand) => (
            <Card key={brand.key} className={`p-6 bg-card shadow-md border-border border-b-4 ${brand.color === 'accent' ? 'border-b-accent border-t-4 border-t-accent' : 'border-b-primary border-t-4 border-t-primary'} hover:shadow-xl transition-all hover:-translate-y-1 flex flex-col`}>
              <brand.icon className={`h-10 w-10 ${brand.color === 'accent' ? 'text-accent' : 'text-primary'} mb-3`} />
              <h3 className="text-lg font-bold text-foreground mb-1">
                {t(`consultantsPage.${brand.key}Name`)}
              </h3>
              <p className="text-sm font-semibold text-accent-text mb-3">
                {t(`consultantsPage.${brand.key}Target`)}
              </p>
              <p className="text-sm text-muted-foreground mb-4 flex-1">
                {brand.desc}
              </p>
              <Button
                size="sm"
                variant="outline"
                className={`w-full font-semibold rounded-xl ${brand.color === 'accent' ? 'border-accent text-accent hover:bg-accent/10' : 'border-primary text-primary hover:bg-primary/10'}`}
                asChild
              >
                <Link to={brand.href}>
                  Bekijk de pagina
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ForConsultants;